import {DND_FLIP_DURATION_MS} from "../data/constants.js";
export const dndFlipOption = {flipDurationMs: DND_FLIP_DURATION_MS};
export const svelteAnimateOptions = {duration: DND_FLIP_DURATION_MS};
export const dndOptions = {
  flipDurationMs: DND_FLIP_DURATION_MS,
  type: "columns"
};
export const reorderItems = (newItems) => {
  return newItems.map((item, index) => ({
    ...item,
    order: index + 1
  }));
};
export const addCategoriesToAreas = (areas, categories) => {
  if (!areas)
    return [];
  if (!categories)
    return areas.map((area) => ({...area, items: []}));
  let tempAreas = {};
  areas.forEach((area) => {
    tempAreas[area.id] = {...area, items: []};
  });
  categories.forEach((cat) => {
    if (tempAreas[cat.areaId])
      tempAreas[cat.areaId].items.push(cat);
  });
  return areas.map((area) => ({...area, items: tempAreas[area.id]["items"]}));
};
export const addGroupedCategoriesToAreas = (areas, groupedCats) => {
  if (!areas)
    return [];
  if (!groupedCats || !Object.values(groupedCats)?.length)
    return areas.map((area) => ({...area, items: []}));
  areas.forEach((area, index) => {
    if (groupedCats[area.id]) {
      areas[index]["items"] = groupedCats[area.id];
    } else {
      areas[index]["items"] = [];
    }
  });
  return areas;
};
export const groupCategoriesByAreaId = (categories) => {
  let tempGroupedCategories = {};
  categories?.forEach((cat) => {
    if (tempGroupedCategories[cat.areaId]) {
      tempGroupedCategories[cat.areaId].push(cat);
    } else {
      tempGroupedCategories[cat.areaId] = [cat];
    }
  });
  return tempGroupedCategories;
};
